import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { apiErrorMessage } from '../core/api-error';
import { API_CLIENT_CONFIG } from '../core/api-client-config';
import {
  ContactClosureReason,
  CreateContactClosureReasonRequest,
  UpdateContactClosureReasonRequest,
} from '../models';

@Injectable({ providedIn: 'root' })
export class AdminContactClosureReasonsApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${inject(API_CLIENT_CONFIG).crmApiBaseUrl}/api/admin/BackofficeContactClosureReasons`;

  getContactClosureReasons(options?: { isActive?: boolean }) {
    let params = new HttpParams();

    if (options?.isActive !== null && options?.isActive !== undefined) {
      params = params.append('isActive', options.isActive);
    }

    return this.httpClient.get<ContactClosureReason[]>(`${this.baseUrl}`, {
      params,
    });
  }

  createContactClosureReason(dto: CreateContactClosureReasonRequest) {
    return this.httpClient.post<{ id: string }>(`${this.baseUrl}`, dto).pipe(
      catchError((error) =>
        throwError(() =>
          apiErrorMessage(error, {
            AlreadyExists: 'Esiste già un motivo con questo nome.',
          }),
        ),
      ),
    );
  }

  updateContactClosureReason(dto: UpdateContactClosureReasonRequest) {
    return this.httpClient.put<void>(`${this.baseUrl}`, dto).pipe(
      catchError((error) =>
        throwError(() =>
          apiErrorMessage(error, {
            AlreadyExists: 'Esiste già un motivo con questo nome.',
            NotFound: 'Il motivo non esiste più.',
          }),
        ),
      ),
    );
  }

  deleteContactClosureReason(id: string) {
    return this.httpClient.delete<void>(`${this.baseUrl}/${id}`).pipe(
      catchError((error) =>
        throwError(() =>
          apiErrorMessage(
            error,
            {
              Generic:
                'Impossibile eliminare il motivo: è usato da almeno uno storico. Disattivalo invece.',
              NotFound: 'Il motivo non esiste più.',
            },
            "Impossibile eliminare il motivo. Riprova più tardi o contatta l'assistenza tecnica.",
          ),
        ),
      ),
    );
  }
}
